import React, { useEffect, useState } from 'react';

import "assets/scss/billingPortal/modules/companyInfo.scss";
import { GeneralTable } from 'components/tables/GeneralTable';
import { companyInfoColumns } from './data/companyInfoColumns';
import { Button } from 'components/buttons/Button';
import { FormInput_text, FormCheckbox } from 'components';
import { useCustomSelector } from 'hooks';
import useCompanyInfoActions from 'dataflow/billingPortal/actions/useCompanyInfo.action';
import { getObjectPropertyValue, isArrayNotEmpty, getArrayLength, getObjectPropertyValue_caseInsensitive, isFunction, isNullUndefined, isObjectEmpty, isObjectNotEmpty, isStringTrimEmpty, isStringTrimNotEmpty } from 'functions';
import { useDropdownLists } from './hooks/useDropdownLists';
import { Toaster } from 'components/notification/Toaster';
import { Dropdown } from 'components/filters/Dropdown';
import { DashboardLayout } from 'components/layout/DashboardLayout';

export default function CompanyInfo() {
    const {
        userPermissions
    } = useCustomSelector("userManagementReducers");

    const {
        companyInfoList, companyInfoListHeaders,
        getCompanyInfoList_requesting
    } = useCustomSelector("companyInfo");

    const { getCompanyInfoList } = useCompanyInfoActions();

    // Dropdowns
    const [serverName, setServerName] = useState();
    const [dbServerName, setDbServerName] = useState();
    const [appVersion, setAppVersion] = useState();
    const [dbVersion, setDbVersion] = useState();

    // Search Inputs
    const [comId, setComId] = useState();
    const [companyName, setCompanyName] = useState();
    const [userEmail, setUserEmail] = useState();
    const [userName, setUserName] = useState();

    // Checkboxes
    const [isValidComId, setIsValidComId] = useState(true);
    const [isGettingUsersForComId, setIsGettingUsersForComId] = useState();

    const [isResetRequired, setIsResetRequired] = useState();
    const [isTableDataVisible, setIsTableDataVisible] = useState(false);
    const [isUserColumnDetailVisible, setIsUserColumnDetailVisible] = useState(false);

    const {
        serverNameList,
        dbServerNameList,
        appVersionList,
        dbVersionList
    } = useDropdownLists();

    useEffect(() => {
        if(isResetRequired) setIsResetRequired(false);
    }, [isResetRequired]);

    function handleOnSubmit(setFilterOptions) {
        if (isFunction(setFilterOptions)) {

            setFilterOptions({
                filters: {
                    ServerName: serverName,
                    XilnexDB: dbServerName,
                    AppVersion: appVersion,
                    DBVersion: dbVersion,
                    ComId: comId,
                    ComName: companyName,
                    UserEmail: userEmail,
                    FirstOrLastName: userName
                },
                validCom: isValidComId,
                userInCom: isGettingUsersForComId
            });

            // resetInput();
            setIsTableDataVisible(true);

            // handle user columns display
            if (isStringTrimNotEmpty(userEmail) ||
                isStringTrimNotEmpty(userName) ||
                isGettingUsersForComId) {
    
                setIsUserColumnDetailVisible(true);
            }
            else setIsUserColumnDetailVisible(false);
        }
        else {
            Toaster({
                type: "error",
                msg: "Invalid DB server name"
            })
        }
    }

    function resetInput() {
        setServerName("");
        setDbServerName("");
        setAppVersion("");
        setDbVersion("");
        setComId("");
        setCompanyName("");
        setUserEmail("");
        setUserName("");
        setIsResetRequired(true);
        setIsValidComId(true); 
        setIsGettingUsersForComId(false);
        setIsTableDataVisible(false);
    }

    let totalRecords = parseInt(getObjectPropertyValue_caseInsensitive(companyInfoListHeaders, "x-total-count"));

    return (
        <DashboardLayout
            headerTitle={"Company Info"}

            bodyClassName={"company-info"}
            body={(
                <div className={"company-info__content"}>
                    {/* Table */}
                    <GeneralTable
                        className={"content__table"}
                        tableWrapperClassName={"table__main-table"}
                        columns={companyInfoColumns.getColumns({
                            userEmail, userName, isGettingUsersForComId, isUserColumnDetailVisible
                        })}
                        data={userPermissions?.Internal_ComInfoTools_View && isTableDataVisible? companyInfoList:[]}
                        minRows={10}

                        getTableData={isTableDataVisible? (pageNo, pageSize, sort, filterOptions) => {
                            let filterOptions_formatted = isObjectEmpty(filterOptions)? filterOptions["validCom"] = true:filterOptions;
                            getCompanyInfoList(pageNo, pageSize, sort, filterOptions_formatted);
                        }:() => {}}

                        outerTableHeaderClassName={"table__header-wrapper"}
                        outerTableHeader={(outerTableHeader_props) => {
                            const { setFilterOptions } = outerTableHeader_props;

                            return (
                                <>
                                    <div className={"header-wrapper__header "}>
                                        {/* Fitlers */}
                                        <div className={"header__filters"}>
                                            {/* Dropdowns */}
                                            <div className={"filters__dropdowns d-flex flex-wrap align-items-center"}>
                                                {/* Server Name */}
                                                <div className={"dropdowns__server-name"}>
                                                    <Dropdown
                                                        selectedValueWrapperClassName={"server-name__input"}
                                                        optionListClassName={"server-name__option-list"}
                                                        options={serverNameList}
                                                        selectedValue_default={serverName}
                                                        onChange={(value, label) => {
                                                            let value_formatted = label;
                                                            if (isStringTrimNotEmpty(value))
                                                                value_formatted = value;
                                                            setServerName(value_formatted);
                                                        }}
                                                        onEnterPressed={() => handleOnSubmit(setFilterOptions)}

                                                        isResetRequired={isResetRequired}
                                                        isDisabled={!(userPermissions?.Internal_ComInfoTools_View)}
                                                        disabledMsg={"'Comp Info: View' permission required"}

                                                        label={"Server Name"}
                                                        isLabelLegend isSearchable isClearable
                                                    />
                                                </div>

                                                {/* DB Server Name */}
                                                <div className={"dropdowns__db-server-name"}>
                                                    <Dropdown
                                                        selectedValueWrapperClassName={"db-server-name__input"}
                                                        optionListClassName={"db-server-name__option-list"}
                                                        options={dbServerNameList}
                                                        selectedValue_default={dbServerName}
                                                        onChange={(value, label) => {
                                                            let value_formatted = label;
                                                            if (isStringTrimNotEmpty(value))
                                                                value_formatted = value;
                                                            setDbServerName(value_formatted);
                                                        }}
                                                        onEnterPressed={() => handleOnSubmit(setFilterOptions)}

                                                        isResetRequired={isResetRequired}
                                                        isDisabled={!(userPermissions?.Internal_ComInfoTools_View)}
                                                        disabledMsg={"'Comp Info: View' permission required"}

                                                        label={"DB Server Name"}
                                                        isLabelLegend isSearchable isClearable
                                                    />
                                                </div>

                                                {/* App Version */}
                                                <div className={"dropdowns__app-version"}>
                                                    <Dropdown
                                                        selectedValueWrapperClassName={"app-version__input"}
                                                        optionListClassName={"app-version__option-list"}
                                                        options={appVersionList}
                                                        selectedValue_default={appVersion}
                                                        onChange={(value, label) => {
                                                            let value_formatted = label;
                                                            if (isStringTrimNotEmpty(value))
                                                                value_formatted = value;
                                                            setAppVersion(value_formatted);
                                                        }}
                                                        onEnterPressed={() => handleOnSubmit(setFilterOptions)}

                                                        isResetRequired={isResetRequired}
                                                        isDisabled={!(userPermissions?.Internal_ComInfoTools_View)}
                                                        disabledMsg={"'Comp Info: View' permission required"}

                                                        label={"App Version"}
                                                        isLabelLegend isSearchable isClearable
                                                    />
                                                </div>

                                                {/* DB Version */}
                                                <div className={"dropdowns__db-version"}>
                                                    <Dropdown
                                                        selectedValueWrapperClassName={"db-version__input"}
                                                        optionListClassName={"db-version__option-list"}
                                                        options={dbVersionList}
                                                        selectedValue_default={dbVersion}
                                                        onChange={(value, label) => {
                                                            let value_formatted = label;
                                                            if (isStringTrimNotEmpty(value))
                                                                value_formatted = value;
                                                            setDbVersion(value_formatted);
                                                        }}
                                                        onEnterPressed={() => handleOnSubmit(setFilterOptions)}

                                                        isResetRequired={isResetRequired}
                                                        isDisabled={!(userPermissions?.Internal_ComInfoTools_View)}
                                                        disabledMsg={"'Comp Info: View' permission required"}

                                                        label={"DB Version"}
                                                        isLabelLegend isSearchable isClearable
                                                    />
                                                </div>
                                            </div>

                                            {/* Search Inputs */}
                                            <div className={"filters__search-inputs d-flex flex-wrap align-items-center"}>
                                                {/* Com ID */}
                                                <FormInput_text  
                                                    customInputClassName={"search-inputs__com-id"}
                                                    
                                                    inputLabel={"COM ID"}

                                                    inputValue_default={comId}

                                                    propagateValueChange={(stateName, value) => { setComId(value); }}
                                                    handleInputEnterKeyPress={() => {
                                                        handleOnSubmit(setFilterOptions);
                                                    }}
                                                    isInputKeyPressHandlingRequired

                                                    isResetRequired={isResetRequired}
                                                    isInputDisabled={!(userPermissions?.Internal_ComInfoTools_View)}
                                                    disabledMsg={"'Comp Info: View' permission required"}

                                                    inputMaxLength={50}

                                                    isMarginBtmOptional isLabelLegend isInputClickHandlingRequired isInputDigitOnly
                                                    isInputOptional
                                                />

                                                {/* Company Name */}
                                                <FormInput_text  
                                                    customInputClassName={"search-inputs__company-name"}
                                                    
                                                    inputLabel={"Company Name"}

                                                    inputValue_default={companyName}

                                                    propagateValueChange={(stateName, value) => { setCompanyName(value); }}
                                                    handleInputEnterKeyPress={() => handleOnSubmit(setFilterOptions)}
                                                    isInputKeyPressHandlingRequired

                                                    isResetRequired={isResetRequired}
                                                    isInputDisabled={!(userPermissions?.Internal_ComInfoTools_View)}
                                                    disabledMsg={"'Comp Info: View' permission required"}

                                                    inputMaxLength={200}

                                                    isMarginBtmOptional isLabelLegend isInputClickHandlingRequired
                                                    isInputOptional
                                                />

                                                {/* User Email */}
                                                <FormInput_text  
                                                    customInputClassName={"search-inputs__user-email"}
                                                    
                                                    inputLabel={"User Email"}

                                                    inputValue_default={userEmail}

                                                    propagateValueChange={(stateName, value) => { 
                                                        setUserEmail(value); 
                                                        
                                                        // if (isStringTrimNotEmpty(value)) setIsGettingUsersForComId(true);
                                                        // else setIsGettingUsersForComId(false);
                                                    }}
                                                    handleInputEnterKeyPress={() => handleOnSubmit(setFilterOptions)}
                                                    isInputKeyPressHandlingRequired

                                                    isResetRequired={isResetRequired}
                                                    isInputDisabled={!(userPermissions?.Internal_ComInfoTools_View)}
                                                    disabledMsg={"'Comp Info: View' permission required"}

                                                    inputMaxLength={200}

                                                    // isInputNotAllowed={isStringTrimEmpty(comId) || !comId}
                                                    // isInputNotAllowedMsg={"COM ID input required"}

                                                    isMarginBtmOptional isLabelLegend isInputClickHandlingRequired
                                                    isInputOptional
                                                />

                                                {/* User Name */}
                                                <FormInput_text  
                                                    customInputClassName={"search-inputs__user-name"}
                                                    
                                                    inputLabel={"User Name"}

                                                    inputValue_default={userName}

                                                    propagateValueChange={(stateName, value) => { 
                                                        setUserName(value); 

                                                        // if (isStringTrimNotEmpty(value)) setIsGettingUsersForComId(true);
                                                        // else setIsGettingUsersForComId(false);
                                                    }}
                                                    handleInputEnterKeyPress={() => handleOnSubmit(setFilterOptions)}
                                                    isInputKeyPressHandlingRequired

                                                    isResetRequired={isResetRequired}
                                                    isInputDisabled={!(userPermissions?.Internal_ComInfoTools_View)}
                                                    disabledMsg={"'Comp Info: View' permission required"}

                                                    inputMaxLength={200}

                                                    // isInputNotAllowed={isStringTrimEmpty(comId) || !comId}
                                                    // isInputNotAllowedMsg={"COM ID input required"}

                                                    isMarginBtmOptional isLabelLegend isInputClickHandlingRequired
                                                    isInputOptional
                                                />
                                            </div>

                                            {/* Checkboxes */}
                                            <div className={"filters__checkboxes d-flex align-items-center flex-wrap"}>
                                                {/* Is Valid Com Id */}
                                                <FormCheckbox
                                                    className={"checkboxes__is-valid-com-id"}
                                                    handleCheckboxSelectionSub={(id, isChecked) => {
                                                        setIsValidComId(isChecked);
                                                    }}

                                                    isCheckboxCheckedDefault={isValidComId}
                                                    checkboxLabel={"Show Valid COM only"}
                                                    isResetRequired={isResetRequired}
                                                    isCheckboxDisabled={!(userPermissions?.Internal_ComInfoTools_View)}
                                                    disabledMsg={"'Comp Info: View' permission required"}
                                                    isCheckboxCheckedDefault
                                                />

                                                {/* Is Getting Users for Related COM Id */}
                                                <FormCheckbox
                                                    className={"checkboxes__is-getting-users-for-com-id"}
                                                    handleCheckboxSelectionSub={(id, isChecked) => {
                                                        setIsGettingUsersForComId(isChecked);
                                                    }}

                                                    isCheckboxCheckedDefault={isGettingUsersForComId}
                                                    isCheckboxDisabled={!(userPermissions?.Internal_ComInfoTools_View)}
                                                    disabledMsg={"'Comp Info: View' permission required"}
                                                    checkboxLabel={"Get Users for related COM ID"}
                                                    isResetRequired={isResetRequired}
                                                    isCheckingNotAllowed={isStringTrimEmpty(comId) || !comId}
                                                    checkingNotAllowedMsg={"COM ID input required"}
                                                />
                                            </div>
                                        </div>

                                        {/* Actions */}
                                        <div className={"header__action d-flex align-items-center justify-content-end"}>
                                            {/* Reset Filter */}
                                            <Button
                                                className={"action__reset-filter d-flex flex-column align-items-center justify-content-center"}
                                                handleOnClick={() => {
                                                    resetInput(setFilterOptions);
                                                    setFilterOptions({});
                                                }}

                                                isDisabled={!(userPermissions?.Internal_ComInfoTools_View)}
                                                disabledMsg={"'Comp Info: View' permission required"}
                                            >
                                                Reset All Filters
                                            </Button>

                                            {/* Apply Filter */}
                                            <Button
                                                className={"action__apply-filter d-flex flex-column align-items-center justify-content-center"}
                                                handleOnClick={() => handleOnSubmit(setFilterOptions)}

                                                isDisabled={!(userPermissions?.Internal_ComInfoTools_View)}
                                                disabledMsg={"'Comp Info: View' permission required"}
                                            >
                                                Apply Filter
                                            </Button>
                                        </div>
                                    </div>

                                    {/* Divider */}
                                    <div className={"header-wrapper__divider"}>
                                        {/* Line */}
                                        <div className={"divider__line"} />

                                        {/* Record Count */}
                                        {isArrayNotEmpty(companyInfoList) && isTableDataVisible && (
                                            <div className={"divider__record-count"}>Record Count: {totalRecords}</div>
                                        )}
                                    </div>
                                </>
                            );
                        }}

                        isTableDataLoading={getCompanyInfoList_requesting}

                        isUsingPagination
                        totalRecords={isTableDataVisible? totalRecords:0}

                        isColumnResizeable
                        isTableOddRowsDarken
                        isTableDataRequestPrevented={!isTableDataVisible} isNoDataHidden
                    />
                </div>
            )}
        />
    );
}